import { __assign } from 'tslib';
import React__default from 'react';
import { toast, Slide } from 'react-toastify';
import Toast from './Toast.component.js';
import styles from './Toast.module.scss.js';

function showToast(toastProps) {
    toast.configure({
        position: 'bottom-left',
        transition: Slide,
        newestOnTop: false,
        closeOnClick: false,
        hideProgressBar: true,
        closeButton: false,
    });
    toast(function (_a) {
        var closeToast = _a.closeToast;
        return (React__default.createElement(Toast, __assign({}, toastProps, { onClose: function () {
                var _a;
                closeToast();
                (_a = toastProps.onClose) === null || _a === void 0 ? void 0 : _a.call(toastProps);
            } })));
    }, {
        className: styles.ToastWrapper,
    });
}

export { showToast as default };
